var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 502.37 502.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0068d1;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_2",
    "data-name": "Exclusion 2",
    d: "M255.82,507.85C117.1,507.86,4.64,395.42,4.63,256.7A251.18,251.18,0,0,1,78.21,79.07C176.3-19,335.34-19,433.43,79.07s98.09,257.13,0,355.23A249.52,249.52,0,0,1,255.82,507.85Zm71.76-305V382.27h71.76V202.86Zm-107.64-89.7V382.27H291.7V113.16ZM112.29,292.57v89.7h71.77v-89.7Z",
    transform: "translate(-4.63 -5.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMax);
export default __webpack_public_path__ + "static/media/iconMax.7f8bd7bcce24e1c670e844d43c792033.svg";
export { ForwardRef as ReactComponent };